import React, { useState } from "react";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";
import { TableRow } from "@material-ui/core";
import { OrderStatusLabelMap, PriceDetail } from "../../../../models/Order";
import moment from "moment";
import useLoadedUser from "../../../hooks/auth/useLoadedUser";
import PermissionGate from "../../../controls/auth/PermissionGate";
import User, { UserRole, UserRoleLabelMap, UserRoleLabelVNMap } from "../../../../models/User";
import { BookingTableBodyButton, BookingTableBodyStauts } from "../../MyBooking/styled/DesStyled";
import useUpdateActiveUserAdmin from "../hook/UpdateActiveUserAdmin";
import useBanUserAdmin from "../hook/BanUserAdmin";
import { ActiveType, ActiveTypeMap } from "../../../../models/Login";
import { deleteUserAdmin } from "../../../../services/UserService";

export default function UserTableBody(props: {
	val: User;
	reload: () => void;
	setIsDialogLoginOpen: (val: boolean) => void;
	setOrderId: (val: string) => void;
	onOpenBan: (id: string) => void;
}) {
	const { user } = useLoadedUser();
	const [anchorEl, setAnchorEl] = useState(null);
	const { openAlertDialog } = useAlertDialog();
	const { ActiveUserAd } = useUpdateActiveUserAdmin({ reload: props.reload });
	const { unbanUserAd } = useBanUserAdmin({ reload: props.reload });

	const handleUpdateStatusStaff = async (id: string, status: boolean) => {
		openAlertDialog?.(
			AlertType.Confirm,
			"You definitely want to change?",
			() => {},
			() => ActiveUserAd(id || "0", status),
			undefined,
			{
				declineText: "Cancel",
				acceptText: "Confirm",
			}
		);
	};

	const handleUpdateOrder = async (id: string) => {
		props.setIsDialogLoginOpen(true);
		props.setOrderId(id);
	};

	const handleUnbanUser = (id: string) => {
		openAlertDialog?.(
			AlertType.Confirm,
			"Remove ban for this user?",
			() => {},
			() => void unbanUserAd(id),
			undefined,
			{
				declineText: "Cancel",
				acceptText: "Unban",
			}
		);
	};

	const handleDeleteUser = async (id: string) => {
		if (String(user?.id) === String(id)) {
			openAlertDialog?.(AlertType.Fail, "You cannot delete your own account.");
			return;
		}
		if (props.val.role === UserRole.Admin) {
			openAlertDialog?.(AlertType.Fail, "Admin accounts cannot be deleted from here.");
			return;
		}
		openAlertDialog?.(
			AlertType.Confirm,
			"Permanently delete this user? Related station data, orders, and history will be removed where applicable. This cannot be undone.",
			() => {},
			async () => {
				try {
					await deleteUserAdmin(id);
					openAlertDialog?.(AlertType.Success, "User deleted.", () => {
						props.reload();
					});
				} catch (err: unknown) {
					const msg =
						err && typeof err === "object" && "response" in err
							? (err as { response?: { data?: { message?: string } } }).response?.data?.message
							: undefined;
					openAlertDialog?.(AlertType.Fail, msg || "Delete failed.");
				}
			},
			undefined,
			{
				declineText: "Cancel",
				acceptText: "Delete",
			}
		);
	};

	return (
		<>
			<TableRow>
				<TableCell align="center">{props.val.id}</TableCell>
				<TableCell align="center"> {props.val.fullName}</TableCell>
				<TableCell align="center">{props.val.email}</TableCell>
				<TableCell align="center">{props.val.phone}</TableCell>
				<TableCell align="center">{UserRoleLabelVNMap.get(props.val.role || 0)}</TableCell>
				<TableCell align="center">{ActiveTypeMap.get(Number(props.val.communicationId)) || "--"}</TableCell>

				<TableCell align="center">{props.val?.active ? "Activate" : "Not activated yet"}</TableCell>

				<TableCell align="center">
					{props.val.isBanned ? (
						<Tooltip
							title={`${props.val.banReason || "Banned"}${
								props.val.bannedAt ? `\n${moment(props.val.bannedAt).format("YYYY-MM-DD HH:mm")}` : ""
							}`}>
							<span style={{ color: "#c62828", fontWeight: 600 }}>Banned</span>
						</Tooltip>
					) : (
						<span style={{ color: "#2e7d32" }}>No</span>
					)}
				</TableCell>

				<TableCell align="center">
					{user?.role != UserRole.Partner && (
						<PermissionGate permission="customers.manage">
							<>
								{String(user?.id) !== String(props.val.id) &&
									props.val.role !== UserRole.Admin &&
									(props.val.isBanned ? (
										<BookingTableBodyButton
											status={1}
											onClick={() => handleUnbanUser(props.val.id || "0")}>
											Unban
										</BookingTableBodyButton>
									) : (
										<BookingTableBodyButton
											status={1}
											onClick={() => props.onOpenBan(props.val.id || "0")}>
											Ban
										</BookingTableBodyButton>
									))}
								<BookingTableBodyButton
									status={1}
									onClick={() =>
										handleUpdateStatusStaff(props.val.id || "0", props.val.active || false)
									}>
									{props.val?.active ? "Deactivate" : "Activate"}
								</BookingTableBodyButton>
								<BookingTableBodyButton
									status={1}
									onClick={() => handleUpdateOrder(props.val.id || "0")}>
									Edit
								</BookingTableBodyButton>
								<BookingTableBodyButton
									status={1}
									onClick={() => handleDeleteUser(props.val.id || "0")}>
									Delete
								</BookingTableBodyButton>
							</>
						</PermissionGate>
					)}
				</TableCell>
			</TableRow>
		</>
	);
}
